module.exports = __webpack_public_path__ + "static/img/kk.d6402c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/kk.png
// module id = ZpBX
// module chunks = 1